/* eslint-disable */
import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import DashboardOverviewCard from "../../../../components/PagesComponents/Organizational/Management/Dashboard/OverviewCard.components";
import eventsIcon from "../../../../assets/Icons/Pages/Organizational/Management/Dashboard/events.svg";
import meetingsIcon from "../../../../assets/Icons/Pages/Organizational/Management/Dashboard/meetings.svg";
import membersIcon from "../../../../assets/Icons/Pages/Organizational/Management/Dashboard/members.svg";
import staffsIcon from "../../../../assets/Icons/Pages/Organizational/Management/Dashboard/staffs.svg";
import "../../../../styles/Pages/Organizational/Management/Dashboard/Dashboard.style.css";
import AppearanceGraph from "../../../../components/PagesComponents/Organizational/Management/Dashboard/AppearanceGraph.components";
import UpcomingEvents from "../../../../components/PagesComponents/Organizational/Management/Dashboard/UpcomingEvents.components";
import UpcomingMeetings from "../../../../components/PagesComponents/Organizational/Management/Dashboard/UpcomingMeetings.components";
import AppearanceInMeetings from "../../../../components/PagesComponents/Organizational/Management/Dashboard/AppearanceInMeetings.component";
import ImportantAppearance from "../../../../components/PagesComponents/Organizational/Management/Dashboard/ImportantAppearance.component";

import { Helmet } from "react-helmet";
const titleToIcon = {
  Members: membersIcon,
  "Total Meetings": meetingsIcon,
  Events: eventsIcon,
  Staffs: staffsIcon,
};

const Body = ({
  overViewCardData,
  lineChartData,
  upcomingEventsData,
  upcomingMeetingsData,
  donutChartData,
  importantAppearanceData,
}) => {
  return (
    <section className="managementDashboard">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <PageHeader />
      <div className="overviewCardContainer">
        {overViewCardData &&
          overViewCardData.map((data, index) => {
            const {
              title,
              presentCount,
              totalCount,
              cardType = "regular",
              bgColor,
            } = data; // Destructure cardType
            const IconComponent = titleToIcon[title];

            return (
              <DashboardOverviewCard
                key={index}
                icon={cardType === "regular" ? IconComponent : null} // Condition for icon
                cardType={cardType} // Pass cardType prop
                title={title}
                presentCount={presentCount}
                totalCount={totalCount}
                bgColor={bgColor}
              />
            );
          })}
      </div>

      <div className="lineGraphEventMeetingDonutAppearanceContainer">
        <div className="appearanceGraphEventsContainer">
          <div className="appearanceGraph">
            <AppearanceGraph graphData={{ lineChartData }} />
          </div>
          <div className="upcomingEventsAndMeetingsContainer">
            <div className="pollingDetailsParentContainer">
              <UpcomingEvents eventsData={upcomingEventsData} />
            </div>
            <div className="pollingDetailsParentContainer">
              <UpcomingMeetings meetingsData={upcomingMeetingsData} />
            </div>
          </div>
        </div>
        <div className="donutAndImportantAppeaaranceContainer">
          <div className="donutChartDiv">
            <AppearanceInMeetings donutChartData={donutChartData} />
          </div>
          <div className="importantAppearanceContainer">
            <ImportantAppearance
              importantAppearanceData={importantAppearanceData}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
